import { connect } from 'react-redux';
import DeletePanelTarget from './deletePanelTarget'

function mapStateToProps(state) { 
	return {
        profile: state.profile
}};

function mapDispatchToProps(dispatch) {
    return({
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(DeletePanelTarget);